import React from 'react';
import { StaticReferencePage } from './StaticReferencePage';
import { useData } from '../../contexts/DataContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { TABLE_COLUMNS } from '../../constants/tables';
import { Unit } from '../../types';

export const UnitsPage: React.FC = () => {
  const { t } = useLanguage();
  const { units } = useData();

  return (
    <StaticReferencePage<Unit>
      title={t('references.units')}
      items={units.items}
      columns={TABLE_COLUMNS.UNITS}
    />
  );
};
